"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.ContactUsColumns = exports.BusinessGroupSubscriptionColumns = exports.BusinessGroupQuantityColumns = exports.BusinessGroupColumns = exports.BusinessGroupVoucherColumns = exports.BusinessGroupUserColumns = exports.RegisterationMethod = exports.UserState = exports.BusinessGroupUserRole = exports.BusinessGroupRequestColumns = exports.RequestState = exports.UserSummaryColumns = exports.SuggestContentColumns = exports.ReportProblemColumns = exports.PolicyType = exports.FaqColumns = exports.AppRateColumns = exports.AppRateOptionType = exports.OrderByDirection = exports.ComparisonType = exports.DataType = exports.UserColumns = exports.OperatingSystems = exports.ResponseCode = exports.Gender = exports.Identity_UserApiKey_Client = exports.Identity_BusinessGroupSubscription_Client = exports.Identity_BusinessGroupQuantity_Client = exports.Identity_BusinessGroupUser_Client = exports.Identity_BusinessGroupRequest_Client = exports.Identity_ContactUs_Client = exports.Identity_BusinessGroupVoucher_Client = exports.Identity_BusinessGroup_Client = exports.Identity_WebHook_Client = exports.Identity_UserSummaries_Client = exports.Identity_Test_Client = exports.Identity_TablePreferences_Client = exports.Identity_SuggestContent_Client = exports.Identity_Role_Client = exports.Identity_RoleClaim_Client = exports.Identity_ReportProblem_Client = exports.Identity_Policies_Client = exports.Identity_Points_Client = exports.Identity_Faqs_Client = exports.Identity_Badges_Client = exports.Identity_BadgeCategories_Client = exports.Identity_AppRates_Client = exports.Identity_Account_Client = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var axios_1 = __importDefault(require("axios"));
var Identity_Account_Client = /** @class */ (function () {
    function Identity_Account_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Register the user using email and password (Scope: Mobile)
     */
    Identity_Account_Client.prototype.register_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRegister_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processRegister_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Sync Google Users using google workspace (Auth policies: 18.31) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.syncGoogleWorkspace_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/sync-google-workspace";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSyncGoogleWorkspace_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processSyncGoogleWorkspace_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Check email validity and existence (Scope: Mobile)
     * @param email (optional)
     */
    Identity_Account_Client.prototype.checkEmail_V1 = function (email, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/check-email?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCheckEmail_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processCheckEmail_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Change the email of the current user (Auth policies: 18.11) (Scope: Mobile; Dashboard)
     * @param input Input containing the old email, new email and the password
     */
    Identity_Account_Client.prototype.changeEmail_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/change-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangeEmail_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processChangeEmail_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Change the password of the current user (Auth policies: 18.18) (Scope: Mobile; Dashboard)
     * @param input Input containing the old password, new password
     */
    Identity_Account_Client.prototype.changePassword_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/change-password";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processChangePassword_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processChangePassword_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update the name of the user (Auth policies: 18.14) (Scope: Mobile)
     * @param input The name of the user
     */
    Identity_Account_Client.prototype.updateName_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/update-name";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateName_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processUpdateName_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update the gender of the user (Auth policies: 18.21) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.updateGender_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/update-gender";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateGender_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processUpdateGender_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create admin using email and password (Auth policies: 18.9) (Scope: Dashboard)
     */
    Identity_Account_Client.prototype.createAdmin_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/create-admin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCreateAdmin_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processCreateAdmin_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get token using id (Auth policies: 18.9) (Scope: Dashboard)
     * @param id (optional)
     */
    Identity_Account_Client.prototype.getToken_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get-token?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetToken_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processGetToken_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get token using id and give validity (Auth policies: 18.9) (Scope: Dashboard)
     * @param id (optional)
     * @param minutes (optional)
     */
    Identity_Account_Client.prototype.getTokenByMinutes_V1 = function (id, minutes, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get-token-by-minutes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (minutes === null)
            throw new Error("The parameter 'minutes' cannot be null.");
        else if (minutes !== undefined)
            url_ += "minutes=" + encodeURIComponent("" + minutes) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetTokenByMinutes_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processGetTokenByMinutes_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get users by using the provided sorting, filtration and pagination options (Auth policies: 18.0) (Scope: Dashboard)
     * @param request Filtration, sorting and pagination options
     * @return Filtration, sorting and pagination options
     */
    Identity_Account_Client.prototype.get_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGet_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processGet_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get team by using the provided sorting, filtration and pagination options (Auth policies: 18.28) (Scope: Dashboard)
     * @param request Filtration, sorting and pagination options
     * @return Filtration, sorting and pagination options
     */
    Identity_Account_Client.prototype.getTeam_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/get-team";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetTeam_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processGetTeam_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get user details using his id (Auth policies: 18.10) (Scope: Dashboard)
     * @param userId user id
     */
    Identity_Account_Client.prototype.userId_V1GET = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserId_V1GET(_response);
        });
    };
    Identity_Account_Client.prototype.processUserId_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Soft deletion of the requested user (Auth policies: 18.4) (Scope: Dashboard)
     * @param userId The of the user to be deleted
     */
    Identity_Account_Client.prototype.userId_V1DELETE = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserId_V1DELETE(_response);
        });
    };
    Identity_Account_Client.prototype.processUserId_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Soft deletion of the current user (Auth policies: 18.5) (Scope: Mobile; Dashboard)
     */
    Identity_Account_Client.prototype.softDelete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/soft-delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSoftDelete_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processSoftDelete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Soft deletion of the current user (Auth policies: 18.25) (Scope: Mobile; Dashboard)
     */
    Identity_Account_Client.prototype.requestDelete_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/request-delete";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRequestDelete_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processRequestDelete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Block for the requested user (Auth policies: 18.7) (Scope: Dashboard)
     * @param userId (optional) The of the user to be blocked
     */
    Identity_Account_Client.prototype.block_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/block?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBlock_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processBlock_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un Block for the requested user (Auth policies: 18.8) (Scope: Dashboard)
     * @param userId (optional) The of the user to be released
     */
    Identity_Account_Client.prototype.unblock_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/unblock?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnblock_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processUnblock_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Email and Password (Scope: Mobile; Dashboard)
     * @param input Email and passowrd
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Refresh user tokens using the expired access token (Scope: Mobile; Dashboard)
     * @param input the expired access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.token_refresh_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/token/refresh";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processToken_refresh_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processToken_refresh_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove all user refresh tokens (Auth policies: 18.6) (Scope: Mobile; Dashboard)
     */
    Identity_Account_Client.prototype.token_revoke_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/token/revoke";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processToken_revoke_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processToken_revoke_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Google (Scope: Mobile)
     * @param input Google access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_google_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/google";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_google_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_google_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Link user using Google (Auth) (Scope: Mobile)
     * @param input Google access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.link_google_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/google";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLink_google_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processLink_google_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate guest (Scope: Mobile)
     * @param input Google access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_guest_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/guest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_guest_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_guest_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Facebook (Scope: Mobile)
     * @param input Facebook access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_facebook_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/facebook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_facebook_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_facebook_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Link user using Facebook (Auth) (Scope: Mobile)
     * @param input Facebook access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.link_facebook_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/facebook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLink_facebook_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processLink_facebook_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete user Facebook data (Scope: Mobile)
     * @param input Facebook access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.delete_facebook_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/delete/facebook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDelete_facebook_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processDelete_facebook_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Legacy (Scope: Mobile)
     * @param input Legacy access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_legacy_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/legacy";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_legacy_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_legacy_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Huawei (Scope: Mobile)
     * @param input Huawei access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_huawei_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/huawei";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_huawei_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_huawei_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Link user using Huawei (Scope: Mobile)
     * @param input Huawei access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.link_huawei_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/huawei";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLink_huawei_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processLink_huawei_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Twitter (Scope: Mobile)
     * @param input Twitter access token
     * @return User info and tokens
     * @deprecated
     */
    Identity_Account_Client.prototype.authenticate_twitter_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_twitter_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_twitter_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Link user using Twitter (Auth) (Scope: Mobile)
     * @param input Twitter access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.link_twitter_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLink_twitter_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processLink_twitter_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Twitter - Get Browser Link - STEP 1 (Scope: Mobile)
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_twitterBrowserLink_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/twitter-browser-link";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_twitterBrowserLink_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_twitterBrowserLink_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Apple (Scope: Mobile)
     * @param input Apple access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_apple_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/authenticate/apple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_apple_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_apple_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Link user using Apple (Auth) (Scope: Mobile)
     * @param input Apple access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.link_apple_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/link/apple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLink_apple_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processLink_apple_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Current User Auth Providers (Auth) (Scope: Mobile)
     * @return User auth providers
     */
    Identity_Account_Client.prototype.authProviders_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/auth-providers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthProviders_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthProviders_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Initiate recover password by email process (Scope: Mobile)
     * @param input User email and the password reset code
     */
    Identity_Account_Client.prototype.passwordReset_request_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/password-reset/request";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPasswordReset_request_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processPasswordReset_request_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Verify if the password reset  code is valid (Scope: Mobile)
     * @param input User email
     */
    Identity_Account_Client.prototype.passwordReset_verify_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/password-reset/verify";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPasswordReset_verify_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processPasswordReset_verify_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Change the password for the user of the given email while using the verified code (Scope: Mobile)
     * @param input User email, new password and the password reset code
     */
    Identity_Account_Client.prototype.passwordReset_reset_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/password-reset/reset";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPasswordReset_reset_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processPasswordReset_reset_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Initiate confirm email process (Auth policies: 18.19) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.requestEmailVerification_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/request-email-verification";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRequestEmailVerification_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processRequestEmailVerification_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Validate the email of the current user (Auth policies: 18.20) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.emailValidation_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/email-validation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEmailValidation_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processEmailValidation_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update user roles (Auth policies: 18.13) (Scope: Dashboard)
     * @param input User id and roles
     */
    Identity_Account_Client.prototype.roles_updateUser_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/roles/update-user";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoles_updateUser_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processRoles_updateUser_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get user roles (Auth policies: 18.12) (Scope: Dashboard)
     * @param userId User id
     */
    Identity_Account_Client.prototype.roles_getUser_userId_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/roles/get-user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoles_getUser_userId_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processRoles_getUser_userId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set user password (Auth policies: 18.15) (Scope: Dashboard)
     * @param input User id
     */
    Identity_Account_Client.prototype.setPassword_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-password";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetPassword_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processSetPassword_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set user email (Auth policies: 18.17) (Scope: Dashboard)
     * @param input User id
     */
    Identity_Account_Client.prototype.setEmail_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetEmail_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processSetEmail_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set my email and password (Auth policies: 18.16) (Scope: Mobile; Dashboard)
     * @param input User id
     */
    Identity_Account_Client.prototype.setMyEmailPassword_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-my-email-password";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetMyEmailPassword_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processSetMyEmailPassword_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Register the user using email and password AND add him to a business group through a voucher (Scope: Web)
     */
    Identity_Account_Client.prototype.register_toBusinessGroup_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/register/to-business-group";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRegister_toBusinessGroup_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processRegister_toBusinessGroup_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Authenticate user using Twitter - STEP 2 (Scope: Mobile)
     * @param input Twitter access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.authenticate_twitter_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/Account/authenticate/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthenticate_twitter_V2(_response);
        });
    };
    Identity_Account_Client.prototype.processAuthenticate_twitter_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Link user using Twitter - STEP 2 (Auth) (Scope: Mobile)
     * @param input Twitter access token
     * @return User info and tokens
     */
    Identity_Account_Client.prototype.link_twitter_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v2/Account/link/twitter";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLink_twitter_V2(_response);
        });
    };
    Identity_Account_Client.prototype.processLink_twitter_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set b2b onboarding as completed (Auth policies: 18.27) (Scope: Mobile)
     * @param input The name of the user
     */
    Identity_Account_Client.prototype.b2bOnboardingComplteted_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/b2b-onboarding-complteted";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processB2bOnboardingComplteted_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processB2bOnboardingComplteted_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set onboarding as completed (Auth policies: 18.26) (Scope: Mobile)
     * @param input The name of the user
     */
    Identity_Account_Client.prototype.onboardingComplteted_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/onboarding-complteted";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOnboardingComplteted_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processOnboardingComplteted_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set autoplay settings (Auth policies: 18.29) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.autoplay_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/autoplay";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAutoplay_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAutoplay_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set next-title settings (Auth policies: 18.30) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.nextTitle_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/next-title";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNextTitle_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processNextTitle_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add User Campaign (Auth policies: 18.30) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.addCampaign_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/add-campaign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddCampaign_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAddCampaign_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Email Verification State (Auth policies: 18.9) (Scope: Mobile)
     */
    Identity_Account_Client.prototype.setEmailVerificationState_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Account/set-email-verification-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetEmailVerificationState_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processSetEmailVerificationState_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get users details By Email (Auth policies: 18.22) (Scope: Dashboard)
     * @param email (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_Account_Client.prototype.account_searchByEmail_V1 = function (email, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Account/search-by-email?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_searchByEmail_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAccount_searchByEmail_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update the name of a user (Auth policies: 18.23) (Scope: Dashboard)
     */
    Identity_Account_Client.prototype.account_updateName_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Account/update-name";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_updateName_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAccount_updateName_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update the gender for a user (Auth policies: 18.24) (Scope: Dashboard)
     */
    Identity_Account_Client.prototype.account_updateGender_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Account/update-gender";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAccount_updateGender_V1(_response);
        });
    };
    Identity_Account_Client.prototype.processAccount_updateGender_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_Account_Client;
}());
exports.Identity_Account_Client = Identity_Account_Client;
var Identity_AppRates_Client = /** @class */ (function () {
    function Identity_AppRates_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Rate App (Auth policies: 85.0) (Scope: Mobile)
     */
    Identity_AppRates_Client.prototype.appRates_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAppRates_post_V1(_response);
        });
    };
    Identity_AppRates_Client.prototype.processAppRates_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create a new App Rate Option for Admin (Auth policies: 85.1) (Scope: Dashboard)
     */
    Identity_AppRates_Client.prototype.options_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOptions_V1POST(_response);
        });
    };
    Identity_AppRates_Client.prototype.processOptions_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update an App Rate Option for Admin (Auth policies: 85.2) (Scope: Dashboard)
     */
    Identity_AppRates_Client.prototype.options_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOptions_V1PUT(_response);
        });
    };
    Identity_AppRates_Client.prototype.processOptions_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete App Rate Option for Admin (Auth policies: 85.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Identity_AppRates_Client.prototype.options_V1DELETE = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates/options?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOptions_V1DELETE(_response);
        });
    };
    Identity_AppRates_Client.prototype.processOptions_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all App rating options for mobile (Auth policies: 85.4) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_AppRates_Client.prototype.options_V1GET = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates/options";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOptions_V1GET(_response);
        });
    };
    Identity_AppRates_Client.prototype.processOptions_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * GET ALL App Rate Options for Admin (Auth policies: 85.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_AppRates_Client.prototype.options_paginated_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates/options/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOptions_paginated_V1(_response);
        });
    };
    Identity_AppRates_Client.prototype.processOptions_paginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * App Rates - Datatable (Auth policies: 85.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_AppRates_Client.prototype.datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/AppRates/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V1(_response);
        });
    };
    Identity_AppRates_Client.prototype.processDatatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_AppRates_Client;
}());
exports.Identity_AppRates_Client = Identity_AppRates_Client;
var Identity_BadgeCategories_Client = /** @class */ (function () {
    function Identity_BadgeCategories_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Badge Category (Auth policies: 77.2) (Scope: Dashboard)
     */
    Identity_BadgeCategories_Client.prototype.badgeCategories_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BadgeCategories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadgeCategories_post_V1(_response);
        });
    };
    Identity_BadgeCategories_Client.prototype.processBadgeCategories_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Badge Category (Auth policies: 77.3) (Scope: Dashboard)
     */
    Identity_BadgeCategories_Client.prototype.badgeCategories_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BadgeCategories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadgeCategories_put_V1(_response);
        });
    };
    Identity_BadgeCategories_Client.prototype.processBadgeCategories_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Badge Categories (Auth policies: 77.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BadgeCategories_Client.prototype.badgeCategories_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BadgeCategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadgeCategories_get_V1(_response);
        });
    };
    Identity_BadgeCategories_Client.prototype.processBadgeCategories_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Badge Category (Auth policies: 77.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Identity_BadgeCategories_Client.prototype.badgeCategories_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BadgeCategories?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadgeCategories_delete_V1(_response);
        });
    };
    Identity_BadgeCategories_Client.prototype.processBadgeCategories_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Badge Categories With Details (Auth policies: 77.5) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BadgeCategories_Client.prototype.withDetails_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BadgeCategories/with-details";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWithDetails_V1(_response);
        });
    };
    Identity_BadgeCategories_Client.prototype.processWithDetails_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Badge Category With its Badges (Auth policies: 77.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Identity_BadgeCategories_Client.prototype.byId_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BadgeCategories/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V1(_response);
        });
    };
    Identity_BadgeCategories_Client.prototype.processById_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_BadgeCategories_Client;
}());
exports.Identity_BadgeCategories_Client = Identity_BadgeCategories_Client;
var Identity_Badges_Client = /** @class */ (function () {
    function Identity_Badges_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Update Badge (Auth policies: 76.3) (Scope: Dashboard)
     */
    Identity_Badges_Client.prototype.badges_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadges_put_V1(_response);
        });
    };
    Identity_Badges_Client.prototype.processBadges_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Badges (Auth policies: 76.0) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_Badges_Client.prototype.badges_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBadges_get_V1(_response);
        });
    };
    Identity_Badges_Client.prototype.processBadges_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Badge Plan (Auth policies: 76.5) (Scope: Dashboard)
     */
    Identity_Badges_Client.prototype.updatePlan_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges/update-plan";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdatePlan_V1(_response);
        });
    };
    Identity_Badges_Client.prototype.processUpdatePlan_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Badge By ID (Auth policies: 76.6) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Identity_Badges_Client.prototype.byId_V12 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V12(_response);
        });
    };
    Identity_Badges_Client.prototype.processById_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Category Badges (Auth policies: 76.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param categoryId (optional)
     */
    Identity_Badges_Client.prototype.category_V1 = function (x_app_language_id, categoryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges/category?";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategory_V1(_response);
        });
    };
    Identity_Badges_Client.prototype.processCategory_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My Badges (Auth policies: 76.1) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_Badges_Client.prototype.my_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges/my";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMy_V1(_response);
        });
    };
    Identity_Badges_Client.prototype.processMy_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Number Of Badges (Auth policies: 76.1) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param numberOfBadges (optional)
     */
    Identity_Badges_Client.prototype.numberOfBadges_V1 = function (x_app_language_id, numberOfBadges, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges/number-of-badges?";
        if (numberOfBadges === null)
            throw new Error("The parameter 'numberOfBadges' cannot be null.");
        else if (numberOfBadges !== undefined)
            url_ += "NumberOfBadges=" + encodeURIComponent("" + numberOfBadges) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNumberOfBadges_V1(_response);
        });
    };
    Identity_Badges_Client.prototype.processNumberOfBadges_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Badge Profile (Auth policies: 76.4) (Scope: Dashboard)
     * @param id (optional)
     * @param languageId (optional)
     */
    Identity_Badges_Client.prototype.profile_V1 = function (id, languageId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Badges/profile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (languageId === null)
            throw new Error("The parameter 'languageId' cannot be null.");
        else if (languageId !== undefined)
            url_ += "LanguageId=" + encodeURIComponent("" + languageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processProfile_V1(_response);
        });
    };
    Identity_Badges_Client.prototype.processProfile_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_Badges_Client;
}());
exports.Identity_Badges_Client = Identity_Badges_Client;
var Identity_Faqs_Client = /** @class */ (function () {
    function Identity_Faqs_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Faq Category For Admin - Localization (Auth policies: 79.2) (Scope: Dashboard)
     */
    Identity_Faqs_Client.prototype.categories_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories_V1POST(_response);
        });
    };
    Identity_Faqs_Client.prototype.processCategories_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Faq Category For Admin - Localization (Auth policies: 79.3) (Scope: Dashboard)
     */
    Identity_Faqs_Client.prototype.categories_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories_V1PUT(_response);
        });
    };
    Identity_Faqs_Client.prototype.processCategories_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Faq Categories Ordered (Auth policies: 79.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_Faqs_Client.prototype.categories_V1GET = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories_V1GET(_response);
        });
    };
    Identity_Faqs_Client.prototype.processCategories_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Faq Category For Admin (Auth policies: 79.4) (Scope: Dashboard)
     */
    Identity_Faqs_Client.prototype.categories_Id_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories_Id_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processCategories_Id_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Faq Category For Admin (Auth policies: 79.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_Faqs_Client.prototype.categories_id_V1 = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories_id_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processCategories_id_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Faq Categories Ordered for Admin (Auth policies: 79.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_Faqs_Client.prototype.categories_paginated_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories_paginated_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processCategories_paginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Faq by Admin - Localization (Auth policies: 78.1) (Scope: Dashboard)
     */
    Identity_Faqs_Client.prototype.faqs_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_post_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processFaqs_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Faq by Admin - Localization (Auth policies: 78.3) (Scope: Dashboard)
     */
    Identity_Faqs_Client.prototype.faqs_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_put_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processFaqs_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Faqs (Auth policies: 78.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_Faqs_Client.prototype.faqs_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFaqs_get_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processFaqs_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Faq by Admin (Auth policies: 78.4) (Scope: Dashboard)
     */
    Identity_Faqs_Client.prototype.id_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Faqs For specific Category - Paginated (Auth policies: 78.2) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_Faqs_Client.prototype.categories_faqs_V1 = function (x_app_language_id, id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/categories/faqs?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCategories_faqs_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processCategories_faqs_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Faqs - Datatable (Auth policies: 78.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_Faqs_Client.prototype.datatable_V12 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V12(_response);
        });
    };
    Identity_Faqs_Client.prototype.processDatatable_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * User Engagement with faq (Auth policies: 78.6) (Scope: Mobile)
     */
    Identity_Faqs_Client.prototype.helpful_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/helpful";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHelpful_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processHelpful_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Search Faqs (Auth policies: 78.7) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_Faqs_Client.prototype.search_V1 = function (x_app_language_id, searchText, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearch_V1(_response);
        });
    };
    Identity_Faqs_Client.prototype.processSearch_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Faq By Id (Auth policies: 78.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Identity_Faqs_Client.prototype.byId_V13 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Faqs/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V13(_response);
        });
    };
    Identity_Faqs_Client.prototype.processById_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_Faqs_Client;
}());
exports.Identity_Faqs_Client = Identity_Faqs_Client;
var Identity_Points_Client = /** @class */ (function () {
    function Identity_Points_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get user points (Auth policies: 74.0) (Scope: Mobile)
     */
    Identity_Points_Client.prototype.points_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Points";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPoints_get_V1(_response);
        });
    };
    Identity_Points_Client.prototype.processPoints_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get user points (Auth policies: 74.2) (Scope: Dashboard)
     * @param userId (optional)
     */
    Identity_Points_Client.prototype.points_V1GET = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Points?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPoints_V1GET(_response);
        });
    };
    Identity_Points_Client.prototype.processPoints_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add Points (Auth policies: 74.1) (Scope: Dashboard)
     */
    Identity_Points_Client.prototype.points_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/Points";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPoints_V1POST(_response);
        });
    };
    Identity_Points_Client.prototype.processPoints_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_Points_Client;
}());
exports.Identity_Points_Client = Identity_Points_Client;
var Identity_Policies_Client = /** @class */ (function () {
    function Identity_Policies_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new policy (Auth policies: 47.1) (Scope: Dashboard)
     */
    Identity_Policies_Client.prototype.policies_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_post_V1(_response);
        });
    };
    Identity_Policies_Client.prototype.processPolicies_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit existing policy (Auth policies: 47.2) (Scope: Dashboard)
     */
    Identity_Policies_Client.prototype.policies_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_put_V1(_response);
        });
    };
    Identity_Policies_Client.prototype.processPolicies_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all policies (Auth policies: 47.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_Policies_Client.prototype.policies_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_get_V1(_response);
        });
    };
    Identity_Policies_Client.prototype.processPolicies_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete policy (Auth policies: 47.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Identity_Policies_Client.prototype.policies_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPolicies_delete_V1(_response);
        });
    };
    Identity_Policies_Client.prototype.processPolicies_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get policy by id (Auth policies: 47.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_Policies_Client.prototype.id_V1GET = function (id, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1GET(_response);
        });
    };
    Identity_Policies_Client.prototype.processId_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get policy by type (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param type (optional)
     */
    Identity_Policies_Client.prototype.byType_V1 = function (x_app_language_id, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Policies/by-type?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1(_response);
        });
    };
    Identity_Policies_Client.prototype.processByType_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_Policies_Client;
}());
exports.Identity_Policies_Client = Identity_Policies_Client;
var Identity_ReportProblem_Client = /** @class */ (function () {
    function Identity_ReportProblem_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * User Reported Problem (Auth policies: 75.5) (Scope: Mobile)
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.reportProblem_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem/report-problem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_V1(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processReportProblem_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create a new Report Problem Option for Admin (Auth policies: 75.2) (Scope: Dashboard)
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.reportProblem_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_post_V1(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processReportProblem_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Report Problem Option For Admin (Auth policies: 75.3) (Scope: Dashboard)
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.reportProblem_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_put_V1(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processReportProblem_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Report Problem Option For Admin (Auth policies: 75.4) (Scope: Dashboard)
     * @param id (optional)
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.reportProblem_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_delete_V1(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processReportProblem_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * GET ALL Report Problem Options (Auth policies: 75.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.reportProblem_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_get_V1(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processReportProblem_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * GET ALL Report Problem Options for Admin (Auth policies: 75.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.paginated_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaginated_V1(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processPaginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Report Problem Datatable (Auth policies: 75.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.datatable_V13 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ReportProblem/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V13(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processDatatable_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Answer User by sending Email (Auth) (Scope: Dashboard)
     * @deprecated
     */
    Identity_ReportProblem_Client.prototype.reportProblem_answer_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/ReportProblem/answer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_answer_V1(_response);
        });
    };
    Identity_ReportProblem_Client.prototype.processReportProblem_answer_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_ReportProblem_Client;
}());
exports.Identity_ReportProblem_Client = Identity_ReportProblem_Client;
var Identity_RoleClaim_Client = /** @class */ (function () {
    function Identity_RoleClaim_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get All Role Claims (Auth policies: 20.0) (Scope: Dashboard)
     * @return All RoleClaims
     */
    Identity_RoleClaim_Client.prototype.roleClaim_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_get_V1(_response);
        });
    };
    Identity_RoleClaim_Client.prototype.processRoleClaim_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add or update a Role Claim (Auth policies: 20.1) (Scope: Dashboard)
     * @return Status 200 OK
     */
    Identity_RoleClaim_Client.prototype.roleClaim_post_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRoleClaim_post_V1(_response);
        });
    };
    Identity_RoleClaim_Client.prototype.processRoleClaim_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Permissions (Auth policies: 20.5) (Scope: Dashboard)
     * @param group (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @return All Permissions
     */
    Identity_RoleClaim_Client.prototype.permissions_V1 = function (group, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/permissions?";
        if (group !== undefined && group !== null)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPermissions_V1(_response);
        });
    };
    Identity_RoleClaim_Client.prototype.processPermissions_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Role Permissions (Auth policies: 20.6) (Scope: Dashboard)
     * @param roleId (optional)
     * @param group (optional)
     * @return All Permissions
     */
    Identity_RoleClaim_Client.prototype.permissions_byRole_V1 = function (roleId, group, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/permissions/by-role?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (group !== undefined && group !== null)
            url_ += "group=" + encodeURIComponent("" + group) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPermissions_byRole_V1(_response);
        });
    };
    Identity_RoleClaim_Client.prototype.processPermissions_byRole_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Role Permissions (Auth policies: 20.7) (Scope: Dashboard)
     * @return All Permissions
     */
    Identity_RoleClaim_Client.prototype.groups_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/groups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGroups_V1(_response);
        });
    };
    Identity_RoleClaim_Client.prototype.processGroups_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Role Claims By Id (Auth policies: 20.0) (Scope: Dashboard)
     * @return Roles RoleClaims
     */
    Identity_RoleClaim_Client.prototype.getByRole_roleId_V1 = function (roleId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/get-by-role/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetByRole_roleId_V1(_response);
        });
    };
    Identity_RoleClaim_Client.prototype.processGetByRole_roleId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete a Role Claim (Auth policies: 20.3) (Scope: Dashboard)
     * @return Status 200 OK
     */
    Identity_RoleClaim_Client.prototype.id_V1DELETE = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/RoleClaim/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1DELETE(_response);
        });
    };
    Identity_RoleClaim_Client.prototype.processId_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_RoleClaim_Client;
}());
exports.Identity_RoleClaim_Client = Identity_RoleClaim_Client;
var Identity_Role_Client = /** @class */ (function () {
    function Identity_Role_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get All Roles (basic, admin etc.) (Auth policies: 19.0) (Scope: Dashboard)
     * @return List of roles
     */
    Identity_Role_Client.prototype.role_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRole_get_V1(_response);
        });
    };
    Identity_Role_Client.prototype.processRole_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add pr update a Role (Auth policies: 19.1) (Scope: Dashboard)
     * @return Status 200 OK
     */
    Identity_Role_Client.prototype.role_post_V1 = function (request, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(request);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRole_post_V1(_response);
        });
    };
    Identity_Role_Client.prototype.processRole_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete a Role (Auth policies: 19.3) (Scope: Dashboard)
     * @return Status 200 OK
     */
    Identity_Role_Client.prototype.id_V1DELETE2 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1DELETE2(_response);
        });
    };
    Identity_Role_Client.prototype.processId_V1DELETE2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Permissions By Role Id (Auth policies: 21.0) (Scope: Dashboard)
     * @param roleId The id of the role
     * @return List of roles permissions
     */
    Identity_Role_Client.prototype.permissions_roleId_V1 = function (roleId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role/permissions/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPermissions_roleId_V1(_response);
        });
    };
    Identity_Role_Client.prototype.processPermissions_roleId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit a Role Claim (Auth policies: 21.1) (Scope: Dashboard)
     */
    Identity_Role_Client.prototype.permissions_update_V1 = function (model, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Role/permissions/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPermissions_update_V1(_response);
        });
    };
    Identity_Role_Client.prototype.processPermissions_update_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_Role_Client;
}());
exports.Identity_Role_Client = Identity_Role_Client;
var Identity_SuggestContent_Client = /** @class */ (function () {
    function Identity_SuggestContent_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * User Added Suggested Content (Auth policies: 80.1) (Scope: Mobile)
     */
    Identity_SuggestContent_Client.prototype.suggestContent_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/SuggestContent";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSuggestContent_post_V1(_response);
        });
    };
    Identity_SuggestContent_Client.prototype.processSuggestContent_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Suggest Content Datatable (Auth policies: 80.0) (Scope: Dashboard)
     */
    Identity_SuggestContent_Client.prototype.datatable_V14 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/SuggestContent/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V14(_response);
        });
    };
    Identity_SuggestContent_Client.prototype.processDatatable_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_SuggestContent_Client;
}());
exports.Identity_SuggestContent_Client = Identity_SuggestContent_Client;
var Identity_TablePreferences_Client = /** @class */ (function () {
    function Identity_TablePreferences_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get All Current user table preferences (Auth policies: 17.0) (Scope: Dashboard)
     * @return List of table preferences
     */
    Identity_TablePreferences_Client.prototype.tablePreferences_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_get_V1(_response);
        });
    };
    Identity_TablePreferences_Client.prototype.processTablePreferences_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add or update the passed table preference for the current user (Auth policies: 17.3) (Scope: Dashboard)
     * @param input Input model
     */
    Identity_TablePreferences_Client.prototype.tablePreferences_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_post_V1(_response);
        });
    };
    Identity_TablePreferences_Client.prototype.processTablePreferences_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove all the table preferences for the current user (Auth policies: 17.4) (Scope: Dashboard)
     * @return base response
     */
    Identity_TablePreferences_Client.prototype.tablePreferences_delete_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTablePreferences_delete_V1(_response);
        });
    };
    Identity_TablePreferences_Client.prototype.processTablePreferences_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Current user table preferences for the given table name (Auth policies: 17.1) (Scope: Dashboard)
     * @param tableName (optional) The name of the table
     * @return List of table preferences
     */
    Identity_TablePreferences_Client.prototype.byTableName_V1GET = function (tableName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/by-table-name?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByTableName_V1GET(_response);
        });
    };
    Identity_TablePreferences_Client.prototype.processByTableName_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove the table preference associated with the given table and the current user (Auth policies: 17.6) (Scope: Dashboard)
     * @param tableName (optional) The name of the table
     * @return base response
     */
    Identity_TablePreferences_Client.prototype.byTableName_V1DELETE = function (tableName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/by-table-name?";
        if (tableName !== undefined && tableName !== null)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByTableName_V1DELETE(_response);
        });
    };
    Identity_TablePreferences_Client.prototype.processByTableName_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Current user table preferences for the given id (Auth policies: 17.2) (Scope: Dashboard)
     * @return table preference
     */
    Identity_TablePreferences_Client.prototype.id_V1GET2 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1GET2(_response);
        });
    };
    Identity_TablePreferences_Client.prototype.processId_V1GET2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove the table preference associated with the given id and the current user (Auth policies: 17.5) (Scope: Dashboard)
     * @param id The id of the table preferences
     * @return base response
     */
    Identity_TablePreferences_Client.prototype.id_V1DELETE3 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/TablePreferences/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processId_V1DELETE3(_response);
        });
    };
    Identity_TablePreferences_Client.prototype.processId_V1DELETE3 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_TablePreferences_Client;
}());
exports.Identity_TablePreferences_Client = Identity_TablePreferences_Client;
var Identity_Test_Client = /** @class */ (function () {
    function Identity_Test_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all tags
     */
    Identity_Test_Client.prototype.test_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/Test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_get_V1(_response);
        });
    };
    Identity_Test_Client.prototype.processTest_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_Test_Client;
}());
exports.Identity_Test_Client = Identity_Test_Client;
var Identity_UserSummaries_Client = /** @class */ (function () {
    function Identity_UserSummaries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Upload User Summary (Auth policies: 81.1) (Scope: Mobile)
     */
    Identity_UserSummaries_Client.prototype.userSummaries_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/UserSummaries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserSummaries_post_V1(_response);
        });
    };
    Identity_UserSummaries_Client.prototype.processUserSummaries_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * User Summary Datatable (Auth policies: 81.0) (Scope: Dashboard)
     */
    Identity_UserSummaries_Client.prototype.datatable_V15 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/UserSummaries/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V15(_response);
        });
    };
    Identity_UserSummaries_Client.prototype.processDatatable_V15 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_UserSummaries_Client;
}());
exports.Identity_UserSummaries_Client = Identity_UserSummaries_Client;
var Identity_WebHook_Client = /** @class */ (function () {
    function Identity_WebHook_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Consume Pubsub Messages (Scope: Dashboard)
     */
    Identity_WebHook_Client.prototype.webHook_post_V1 = function (pushBody, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/WebHook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(pushBody);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebHook_post_V1(_response);
        });
    };
    Identity_WebHook_Client.prototype.processWebHook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_WebHook_Client;
}());
exports.Identity_WebHook_Client = Identity_WebHook_Client;
var Identity_BusinessGroup_Client = /** @class */ (function () {
    function Identity_BusinessGroup_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get Business Group By Voucher (Auth policies: 88.5) (Scope: Dashboard)
     * @param voucher (optional)
     */
    Identity_BusinessGroup_Client.prototype.byVoucher_V1 = function (voucher, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroup/by-voucher?";
        if (voucher !== undefined && voucher !== null)
            url_ += "Voucher=" + encodeURIComponent("" + voucher) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByVoucher_V1(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processByVoucher_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My Business Group (Auth policies: 88.6) (Scope: Dashboard)
     * @param input (optional)
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_get_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroup?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_get_V1(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update My Business Group (Auth policies: 88.3) (Scope: Dashboard)
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_V1PUT(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My Business Group (Auth policies: 88.6) (Scope: Dashboard)
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_V1GET = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_V1GET(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Business Group (Auth policies: 88.1) (Scope: Dashboard)
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_V1POST(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Business Group (Auth policies: 88.2) (Scope: Dashboard)
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_V1PUT2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_V1PUT2(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_V1PUT2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Business Groups Paginated (Auth policies: 88.0) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_V1GET2 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_V1GET2(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_V1GET2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group By Id (Auth policies: 88.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_byId_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_byId_V1(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Groups Datatable (Auth policies: 88.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroup_Client.prototype.businessGroup_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroup/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroup_datatable_V1(_response);
        });
    };
    Identity_BusinessGroup_Client.prototype.processBusinessGroup_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_BusinessGroup_Client;
}());
exports.Identity_BusinessGroup_Client = Identity_BusinessGroup_Client;
var Identity_BusinessGroupVoucher_Client = /** @class */ (function () {
    function Identity_BusinessGroupVoucher_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Consume Business Group Voucher (Auth policies: 95.3) (Scope: Dashboard)
     */
    Identity_BusinessGroupVoucher_Client.prototype.consume_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/BusinessGroupVoucher/consume";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConsume_V1(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processConsume_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My Business Group Vouchers (Auth policies: 95.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_V1GET = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_V1GET(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create My Business Group Voucher (Auth policies: 95.0) (Scope: Dashboard)
     */
    Identity_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_V1POST(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit My Business Group Voucher (Auth policies: 95.7) (Scope: Dashboard)
     */
    Identity_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_V1PUT(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My Business Group Voucher by id (Auth policies: 95.6) (Scope: Dashboard)
     * @param businessGroupVoucherId (optional)
     */
    Identity_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_byId_V1 = function (businessGroupVoucherId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/by-id?";
        if (businessGroupVoucherId === null)
            throw new Error("The parameter 'businessGroupVoucherId' cannot be null.");
        else if (businessGroupVoucherId !== undefined)
            url_ += "BusinessGroupVoucherId=" + encodeURIComponent("" + businessGroupVoucherId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_byId_V1(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Business Group voucher published state (Auth policies: 95.5) (Scope: Dashboard)
     */
    Identity_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_setPublished_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/set-published";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_setPublished_V1(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_setPublished_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Expire My Business Group Voucher (Auth policies: 95.4) (Scope: Dashboard)
     */
    Identity_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_expire_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/expire";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_expire_V1(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_expire_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Group Voucher Datatable (Auth policies: 95.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroupVoucher_Client.prototype.businessGroupVoucher_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupVoucher/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupVoucher_datatable_V1(_response);
        });
    };
    Identity_BusinessGroupVoucher_Client.prototype.processBusinessGroupVoucher_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_BusinessGroupVoucher_Client;
}());
exports.Identity_BusinessGroupVoucher_Client = Identity_BusinessGroupVoucher_Client;
var Identity_ContactUs_Client = /** @class */ (function () {
    function Identity_ContactUs_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * User Contacted Us (Auth policies: 86.0) (Scope: Mobile)
     */
    Identity_ContactUs_Client.prototype.contactUs_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/ContactUs";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContactUs_post_V1(_response);
        });
    };
    Identity_ContactUs_Client.prototype.processContactUs_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Contact Us - Datatable (Auth policies: 86.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_ContactUs_Client.prototype.contactUs_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/ContactUs/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContactUs_datatable_V1(_response);
        });
    };
    Identity_ContactUs_Client.prototype.processContactUs_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Answer User by sending an Email (Auth policies: 86.2) (Scope: Dashboard)
     */
    Identity_ContactUs_Client.prototype.contactUs_answer_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/ContactUs/answer";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContactUs_answer_V1(_response);
        });
    };
    Identity_ContactUs_Client.prototype.processContactUs_answer_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_ContactUs_Client;
}());
exports.Identity_ContactUs_Client = Identity_ContactUs_Client;
var Identity_BusinessGroupRequest_Client = /** @class */ (function () {
    function Identity_BusinessGroupRequest_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get My Business Group Voucher Requests (Auth policies: 96.0) (Scope: Dashboard)
     * @param businessGroupVoucherId (optional)
     * @param requestState (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_V1 = function (businessGroupVoucherId, requestState, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest?";
        if (businessGroupVoucherId === null)
            throw new Error("The parameter 'businessGroupVoucherId' cannot be null.");
        else if (businessGroupVoucherId !== undefined)
            url_ += "BusinessGroupVoucherId=" + encodeURIComponent("" + businessGroupVoucherId) + "&";
        if (requestState !== undefined && requestState !== null)
            url_ += "RequestState=" + encodeURIComponent("" + requestState) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My Business Group Requests (Auth policies: 96.6) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param requestState (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_byGroupId_V1 = function (businessGroupId, requestState, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/by-group-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (requestState !== undefined && requestState !== null)
            url_ += "RequestState=" + encodeURIComponent("" + requestState) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_byGroupId_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_byGroupId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Approve Business Group voucher requests (Auth policies: 96.2) (Scope: Dashboard)
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_approve_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/approve";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_approve_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_approve_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Approve All Business Group voucher requests (Auth policies: 96.3) (Scope: Dashboard)
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_approveAll_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/approve-all";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_approveAll_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_approveAll_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Reject Business Group voucher requests (Auth policies: 96.4) (Scope: Dashboard)
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_reject_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/reject";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_reject_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_reject_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Reject All Business Group voucher requests (Auth policies: 96.5) (Scope: Dashboard)
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_rejectAll_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/reject-all";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_rejectAll_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_rejectAll_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Group Voucher Requests Datatable (Auth policies: 96.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_datatable_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Group Requests Datatable (Auth policies: 96.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroupRequest_Client.prototype.businessGroupRequest_byGroupId_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupRequest/by-group-id/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupRequest_byGroupId_datatable_V1(_response);
        });
    };
    Identity_BusinessGroupRequest_Client.prototype.processBusinessGroupRequest_byGroupId_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_BusinessGroupRequest_Client;
}());
exports.Identity_BusinessGroupRequest_Client = Identity_BusinessGroupRequest_Client;
var Identity_BusinessGroupUser_Client = /** @class */ (function () {
    function Identity_BusinessGroupUser_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create My Business Group User (Auth policies: 91.8) (Scope: Dashboard)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_V1POST(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All My Business Group Users Paginated (Auth policies: 91.6) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_V1GET = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_V1GET(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Bulk Create Business Group Users (Auth policies: 91.11) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pricesFile (optional)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_bulk_V1 = function (businessGroupId, pricesFile, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/bulk";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = new FormData();
        if (businessGroupId === null || businessGroupId === undefined)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else
            content_.append("BusinessGroupId", businessGroupId.toString());
        if (pricesFile !== null && pricesFile !== undefined)
            content_.append("PricesFile", pricesFile.data, pricesFile.fileName ? pricesFile.fileName : "PricesFile");
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_bulk_V1(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_bulk_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set My Business Group User Role (Auth policies: 91.9) (Scope: Dashboard)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_setRole_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/set-role";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_setRole_V1(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_setRole_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set My Business Group User State (Auth policies: 91.10) (Scope: Dashboard)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_setState_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/set-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_setState_V1(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_setState_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Group Users Datatable (Auth policies: 91.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_datatable_V1(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Search Business Group Users by email (Auth policies: 91.12) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param email (optional)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_searchByEmail_V1 = function (x_app_language_id, businessGroupId, email, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/search-by-email?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_searchByEmail_V1(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_searchByEmail_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get User By Id (Auth policies: 91.13) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param userId (optional)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_userById_V1 = function (x_app_language_id, businessGroupId, userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/business/BusinessGroupUser/user-by-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_userById_V1(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_userById_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Business Group User (Auth policies: 91.1) (Scope: Dashboard)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_V1POST2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_V1POST2(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_V1POST2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Business Group Users Paginated (Auth policies: 91.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_V1GET2 = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_V1GET2(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_V1GET2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Business Group User Role (Auth policies: 91.2) (Scope: Dashboard)
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_setRole_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/set-role";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_setRole_V12(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_setRole_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Group Users Datatable (Auth policies: 91.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroupUser_Client.prototype.businessGroupUser_datatable_V12 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupUser/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupUser_datatable_V12(_response);
        });
    };
    Identity_BusinessGroupUser_Client.prototype.processBusinessGroupUser_datatable_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_BusinessGroupUser_Client;
}());
exports.Identity_BusinessGroupUser_Client = Identity_BusinessGroupUser_Client;
var Identity_BusinessGroupQuantity_Client = /** @class */ (function () {
    function Identity_BusinessGroupQuantity_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Business Group Quantity (Auth policies: 93.1) (Scope: Dashboard)
     */
    Identity_BusinessGroupQuantity_Client.prototype.businessGroupQuantity_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupQuantity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQuantity_V1POST(_response);
        });
    };
    Identity_BusinessGroupQuantity_Client.prototype.processBusinessGroupQuantity_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Business Group Quantities Paginated (Auth policies: 93.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroupQuantity_Client.prototype.businessGroupQuantity_V1GET = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupQuantity?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQuantity_V1GET(_response);
        });
    };
    Identity_BusinessGroupQuantity_Client.prototype.processBusinessGroupQuantity_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Group Quantities Datatable (Auth policies: 93.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroupQuantity_Client.prototype.businessGroupQuantity_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupQuantity/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQuantity_datatable_V1(_response);
        });
    };
    Identity_BusinessGroupQuantity_Client.prototype.processBusinessGroupQuantity_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_BusinessGroupQuantity_Client;
}());
exports.Identity_BusinessGroupQuantity_Client = Identity_BusinessGroupQuantity_Client;
var Identity_BusinessGroupSubscription_Client = /** @class */ (function () {
    function Identity_BusinessGroupSubscription_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Business Group Subscription (Auth policies: 92.1) (Scope: Dashboard)
     */
    Identity_BusinessGroupSubscription_Client.prototype.businessGroupSubscription_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSubscription_V1POST(_response);
        });
    };
    Identity_BusinessGroupSubscription_Client.prototype.processBusinessGroupSubscription_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Business Group Subscriptions Paginated (Auth policies: 92.0) (Scope: Dashboard)
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_BusinessGroupSubscription_Client.prototype.businessGroupSubscription_V1GET = function (businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSubscription_V1GET(_response);
        });
    };
    Identity_BusinessGroupSubscription_Client.prototype.processBusinessGroupSubscription_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Expire Business Group User Role (Auth policies: 92.2) (Scope: Dashboard)
     */
    Identity_BusinessGroupSubscription_Client.prototype.businessGroupSubscription_expire_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription/expire";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSubscription_expire_V1(_response);
        });
    };
    Identity_BusinessGroupSubscription_Client.prototype.processBusinessGroupSubscription_expire_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Business Group Subscripiton Datatable (Auth policies: 92.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Identity_BusinessGroupSubscription_Client.prototype.businessGroupSubscription_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/BusinessGroupSubscription/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSubscription_datatable_V1(_response);
        });
    };
    Identity_BusinessGroupSubscription_Client.prototype.processBusinessGroupSubscription_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_BusinessGroupSubscription_Client;
}());
exports.Identity_BusinessGroupSubscription_Client = Identity_BusinessGroupSubscription_Client;
var Identity_UserApiKey_Client = /** @class */ (function () {
    function Identity_UserApiKey_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Api key for the current user (Auth policies: 124.0) (Scope: Dashboard)
     */
    Identity_UserApiKey_Client.prototype.userApiKey_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserApiKey_V1POST(_response);
        });
    };
    Identity_UserApiKey_Client.prototype.processUserApiKey_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete User Api key for the current user (Auth policies: 124.1) (Scope: Dashboard)
     * @param id (optional)
     */
    Identity_UserApiKey_Client.prototype.userApiKey_V1DELETE = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserApiKey_V1DELETE(_response);
        });
    };
    Identity_UserApiKey_Client.prototype.processUserApiKey_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Current user api keys (Auth policies: 124.3) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Identity_UserApiKey_Client.prototype.userApiKey_V1GET = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserApiKey_V1GET(_response);
        });
    };
    Identity_UserApiKey_Client.prototype.processUserApiKey_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Api key state for the current user (Auth policies: 124.2) (Scope: Dashboard)
     */
    Identity_UserApiKey_Client.prototype.userApiKey_state_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/identity/v1/admin/UserApiKey/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserApiKey_state_V1(_response);
        });
    };
    Identity_UserApiKey_Client.prototype.processUserApiKey_state_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Identity_UserApiKey_Client;
}());
exports.Identity_UserApiKey_Client = Identity_UserApiKey_Client;
/** 0 = Male 1 = Female */
var Gender;
(function (Gender) {
    Gender[Gender["Male"] = 0] = "Male";
    Gender[Gender["Female"] = 1] = "Female";
})(Gender = exports.Gender || (exports.Gender = {}));
/** 0 = Success 400 = BadRequest 403 = Forbidden 404 = NotFound 404 = UserNotFound 404 = RoleNotFound 404 = RoleClaimNotFound 405 = Unauthorized 406 = NotAcceptable 407 = MaxNumberOfSimultaneousLogins 410 = DeletionNotAllowed 411 = AlreadyExist 412 = InvalidEmail 413 = InvalidCode 414 = EmailTaken 415 = UserBlocked 416 = InvalidCredentials 417 = InvalidPassword 500 = InternalServerError */
var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    ResponseCode[ResponseCode["BadRequest"] = 400] = "BadRequest";
    ResponseCode[ResponseCode["Forbidden"] = 403] = "Forbidden";
    ResponseCode[ResponseCode["NotFound"] = 404] = "NotFound";
    ResponseCode[ResponseCode["UserNotFound"] = 404] = "UserNotFound";
    ResponseCode[ResponseCode["RoleNotFound"] = 404] = "RoleNotFound";
    ResponseCode[ResponseCode["RoleClaimNotFound"] = 404] = "RoleClaimNotFound";
    ResponseCode[ResponseCode["Unauthorized"] = 405] = "Unauthorized";
    ResponseCode[ResponseCode["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseCode[ResponseCode["MaxNumberOfSimultaneousLogins"] = 407] = "MaxNumberOfSimultaneousLogins";
    ResponseCode[ResponseCode["DeletionNotAllowed"] = 410] = "DeletionNotAllowed";
    ResponseCode[ResponseCode["AlreadyExist"] = 411] = "AlreadyExist";
    ResponseCode[ResponseCode["InvalidEmail"] = 412] = "InvalidEmail";
    ResponseCode[ResponseCode["InvalidCode"] = 413] = "InvalidCode";
    ResponseCode[ResponseCode["EmailTaken"] = 414] = "EmailTaken";
    ResponseCode[ResponseCode["UserBlocked"] = 415] = "UserBlocked";
    ResponseCode[ResponseCode["InvalidCredentials"] = 416] = "InvalidCredentials";
    ResponseCode[ResponseCode["InvalidPassword"] = 417] = "InvalidPassword";
    ResponseCode[ResponseCode["InternalServerError"] = 500] = "InternalServerError";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
/** 0 = Apple 1 = Google 2 = Huawei 3 = Others */
var OperatingSystems;
(function (OperatingSystems) {
    OperatingSystems[OperatingSystems["Apple"] = 0] = "Apple";
    OperatingSystems[OperatingSystems["Google"] = 1] = "Google";
    OperatingSystems[OperatingSystems["Huawei"] = 2] = "Huawei";
    OperatingSystems[OperatingSystems["Others"] = 3] = "Others";
})(OperatingSystems = exports.OperatingSystems || (exports.OperatingSystems = {}));
/** Enum to crate datatable from UserOutput 0 = Default 1 = Id 2 = Name 4 = Email 8 = CreatedDate 16 = IsBlocked 32 = UpdatedDate 64 = PhoneNumber 128 = Gender 256 = ProfilePictureUrl 512 = IsVerified 1024 = Plans */
var UserColumns;
(function (UserColumns) {
    UserColumns[UserColumns["Default"] = 0] = "Default";
    UserColumns[UserColumns["Id"] = 1] = "Id";
    UserColumns[UserColumns["Name"] = 2] = "Name";
    UserColumns[UserColumns["Email"] = 4] = "Email";
    UserColumns[UserColumns["CreatedDate"] = 8] = "CreatedDate";
    UserColumns[UserColumns["IsBlocked"] = 16] = "IsBlocked";
    UserColumns[UserColumns["UpdatedDate"] = 32] = "UpdatedDate";
    UserColumns[UserColumns["PhoneNumber"] = 64] = "PhoneNumber";
    UserColumns[UserColumns["Gender"] = 128] = "Gender";
    UserColumns[UserColumns["ProfilePictureUrl"] = 256] = "ProfilePictureUrl";
    UserColumns[UserColumns["IsVerified"] = 512] = "IsVerified";
    UserColumns[UserColumns["Plans"] = 1024] = "Plans";
})(UserColumns = exports.UserColumns || (exports.UserColumns = {}));
/** Types of the data inside columns 0 = String 1 = Guid 2 = Number 3 = Image 4 = Boolean 5 = DateTime 6 = NumberMS 7 = NumberCurrency 8 = Date */
var DataType;
(function (DataType) {
    DataType[DataType["String"] = 0] = "String";
    DataType[DataType["Guid"] = 1] = "Guid";
    DataType[DataType["Number"] = 2] = "Number";
    DataType[DataType["Image"] = 3] = "Image";
    DataType[DataType["Boolean"] = 4] = "Boolean";
    DataType[DataType["DateTime"] = 5] = "DateTime";
    DataType[DataType["NumberMS"] = 6] = "NumberMS";
    DataType[DataType["NumberCurrency"] = 7] = "NumberCurrency";
    DataType[DataType["Date"] = 8] = "Date";
})(DataType = exports.DataType || (exports.DataType = {}));
/** The Comparison type that will be done between the selected column and the criteria 0 = Equal 1 = NotEqual 2 = Contain 3 = Greater 4 = GreaterOrEqual 5 = Less 6 = LessOrEqual 7 = Between */
var ComparisonType;
(function (ComparisonType) {
    ComparisonType[ComparisonType["Equal"] = 0] = "Equal";
    ComparisonType[ComparisonType["NotEqual"] = 1] = "NotEqual";
    ComparisonType[ComparisonType["Contain"] = 2] = "Contain";
    ComparisonType[ComparisonType["Greater"] = 3] = "Greater";
    ComparisonType[ComparisonType["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    ComparisonType[ComparisonType["Less"] = 5] = "Less";
    ComparisonType[ComparisonType["LessOrEqual"] = 6] = "LessOrEqual";
    ComparisonType[ComparisonType["Between"] = 7] = "Between";
})(ComparisonType = exports.ComparisonType || (exports.ComparisonType = {}));
/** The direction of the sorting operation 0 = Ascending 1 = Descending */
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection[OrderByDirection["Ascending"] = 0] = "Ascending";
    OrderByDirection[OrderByDirection["Descending"] = 1] = "Descending";
})(OrderByDirection = exports.OrderByDirection || (exports.OrderByDirection = {}));
/** 1 = VeryBad 2 = Bad 3 = Neutral 4 = Good 5 = VeryGood */
var AppRateOptionType;
(function (AppRateOptionType) {
    AppRateOptionType[AppRateOptionType["VeryBad"] = 1] = "VeryBad";
    AppRateOptionType[AppRateOptionType["Bad"] = 2] = "Bad";
    AppRateOptionType[AppRateOptionType["Neutral"] = 3] = "Neutral";
    AppRateOptionType[AppRateOptionType["Good"] = 4] = "Good";
    AppRateOptionType[AppRateOptionType["VeryGood"] = 5] = "VeryGood";
})(AppRateOptionType = exports.AppRateOptionType || (exports.AppRateOptionType = {}));
/** 0 = Default 1 = UserId 2 = Rate 4 = Notes 8 = CreatedDate 16 = Options */
var AppRateColumns;
(function (AppRateColumns) {
    AppRateColumns[AppRateColumns["Default"] = 0] = "Default";
    AppRateColumns[AppRateColumns["UserId"] = 1] = "UserId";
    AppRateColumns[AppRateColumns["Rate"] = 2] = "Rate";
    AppRateColumns[AppRateColumns["Notes"] = 4] = "Notes";
    AppRateColumns[AppRateColumns["CreatedDate"] = 8] = "CreatedDate";
    AppRateColumns[AppRateColumns["Options"] = 16] = "Options";
})(AppRateColumns = exports.AppRateColumns || (exports.AppRateColumns = {}));
/** 0 = Default 1 = Id 2 = Question 4 = Answer */
var FaqColumns;
(function (FaqColumns) {
    FaqColumns[FaqColumns["Default"] = 0] = "Default";
    FaqColumns[FaqColumns["Id"] = 1] = "Id";
    FaqColumns[FaqColumns["Question"] = 2] = "Question";
    FaqColumns[FaqColumns["Answer"] = 4] = "Answer";
})(FaqColumns = exports.FaqColumns || (exports.FaqColumns = {}));
/** 0 = PrivacyPolicy 1 = TermsOfService 2 = About */
var PolicyType;
(function (PolicyType) {
    PolicyType[PolicyType["PrivacyPolicy"] = 0] = "PrivacyPolicy";
    PolicyType[PolicyType["TermsOfService"] = 1] = "TermsOfService";
    PolicyType[PolicyType["About"] = 2] = "About";
})(PolicyType = exports.PolicyType || (exports.PolicyType = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Email 8 = ProblemOptionType 16 = Text 32 = State */
var ReportProblemColumns;
(function (ReportProblemColumns) {
    ReportProblemColumns[ReportProblemColumns["Default"] = 0] = "Default";
    ReportProblemColumns[ReportProblemColumns["Id"] = 1] = "Id";
    ReportProblemColumns[ReportProblemColumns["UserId"] = 2] = "UserId";
    ReportProblemColumns[ReportProblemColumns["Email"] = 4] = "Email";
    ReportProblemColumns[ReportProblemColumns["ProblemOptionType"] = 8] = "ProblemOptionType";
    ReportProblemColumns[ReportProblemColumns["Text"] = 16] = "Text";
    ReportProblemColumns[ReportProblemColumns["State"] = 32] = "State";
})(ReportProblemColumns = exports.ReportProblemColumns || (exports.ReportProblemColumns = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Title 8 = CreateDate */
var SuggestContentColumns;
(function (SuggestContentColumns) {
    SuggestContentColumns[SuggestContentColumns["Default"] = 0] = "Default";
    SuggestContentColumns[SuggestContentColumns["Id"] = 1] = "Id";
    SuggestContentColumns[SuggestContentColumns["UserId"] = 2] = "UserId";
    SuggestContentColumns[SuggestContentColumns["Title"] = 4] = "Title";
    SuggestContentColumns[SuggestContentColumns["CreateDate"] = 8] = "CreateDate";
})(SuggestContentColumns = exports.SuggestContentColumns || (exports.SuggestContentColumns = {}));
/** 0 = Default 1 = UserId 2 = Email 4 = PhoneNumber 8 = SummaryReference 16 = CreatedDate */
var UserSummaryColumns;
(function (UserSummaryColumns) {
    UserSummaryColumns[UserSummaryColumns["Default"] = 0] = "Default";
    UserSummaryColumns[UserSummaryColumns["UserId"] = 1] = "UserId";
    UserSummaryColumns[UserSummaryColumns["Email"] = 2] = "Email";
    UserSummaryColumns[UserSummaryColumns["PhoneNumber"] = 4] = "PhoneNumber";
    UserSummaryColumns[UserSummaryColumns["SummaryReference"] = 8] = "SummaryReference";
    UserSummaryColumns[UserSummaryColumns["CreatedDate"] = 16] = "CreatedDate";
})(UserSummaryColumns = exports.UserSummaryColumns || (exports.UserSummaryColumns = {}));
/** 0 = Pending 1 = Accepted 2 = Rejected */
var RequestState;
(function (RequestState) {
    RequestState[RequestState["Pending"] = 0] = "Pending";
    RequestState[RequestState["Accepted"] = 1] = "Accepted";
    RequestState[RequestState["Rejected"] = 2] = "Rejected";
})(RequestState = exports.RequestState || (exports.RequestState = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Name 8 = Email 16 = Voucher 32 = RequestState 64 = RequestDate */
var BusinessGroupRequestColumns;
(function (BusinessGroupRequestColumns) {
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Default"] = 0] = "Default";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Id"] = 1] = "Id";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["UserId"] = 2] = "UserId";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Name"] = 4] = "Name";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Email"] = 8] = "Email";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["Voucher"] = 16] = "Voucher";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["RequestState"] = 32] = "RequestState";
    BusinessGroupRequestColumns[BusinessGroupRequestColumns["RequestDate"] = 64] = "RequestDate";
})(BusinessGroupRequestColumns = exports.BusinessGroupRequestColumns || (exports.BusinessGroupRequestColumns = {}));
/** 0 = User 1 = Moderator 2 = Admin */
var BusinessGroupUserRole;
(function (BusinessGroupUserRole) {
    BusinessGroupUserRole[BusinessGroupUserRole["User"] = 0] = "User";
    BusinessGroupUserRole[BusinessGroupUserRole["Moderator"] = 1] = "Moderator";
    BusinessGroupUserRole[BusinessGroupUserRole["Admin"] = 2] = "Admin";
})(BusinessGroupUserRole = exports.BusinessGroupUserRole || (exports.BusinessGroupUserRole = {}));
/** 0 = Activated 1 = DeActivated */
var UserState;
(function (UserState) {
    UserState[UserState["Activated"] = 0] = "Activated";
    UserState[UserState["DeActivated"] = 1] = "DeActivated";
})(UserState = exports.UserState || (exports.UserState = {}));
/** 0 = Manually 1 = Document 2 = Voucher 3 = WajeezAdmin 4 = Domain */
var RegisterationMethod;
(function (RegisterationMethod) {
    RegisterationMethod[RegisterationMethod["Manually"] = 0] = "Manually";
    RegisterationMethod[RegisterationMethod["Document"] = 1] = "Document";
    RegisterationMethod[RegisterationMethod["Voucher"] = 2] = "Voucher";
    RegisterationMethod[RegisterationMethod["WajeezAdmin"] = 3] = "WajeezAdmin";
    RegisterationMethod[RegisterationMethod["Domain"] = 4] = "Domain";
})(RegisterationMethod = exports.RegisterationMethod || (exports.RegisterationMethod = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Name 8 = Email 16 = UserState 32 = UserUserRoleRole 64 = RegisterationMethod */
var BusinessGroupUserColumns;
(function (BusinessGroupUserColumns) {
    BusinessGroupUserColumns[BusinessGroupUserColumns["Default"] = 0] = "Default";
    BusinessGroupUserColumns[BusinessGroupUserColumns["Id"] = 1] = "Id";
    BusinessGroupUserColumns[BusinessGroupUserColumns["UserId"] = 2] = "UserId";
    BusinessGroupUserColumns[BusinessGroupUserColumns["Name"] = 4] = "Name";
    BusinessGroupUserColumns[BusinessGroupUserColumns["Email"] = 8] = "Email";
    BusinessGroupUserColumns[BusinessGroupUserColumns["UserState"] = 16] = "UserState";
    BusinessGroupUserColumns[BusinessGroupUserColumns["UserUserRoleRole"] = 32] = "UserUserRoleRole";
    BusinessGroupUserColumns[BusinessGroupUserColumns["RegisterationMethod"] = 64] = "RegisterationMethod";
})(BusinessGroupUserColumns = exports.BusinessGroupUserColumns || (exports.BusinessGroupUserColumns = {}));
/** 0 = Default 1 = Id 2 = Code 4 = Accepted 8 = Rejected 16 = Pending 32 = UsageLimit 64 = StartDate 128 = ExpirationDate 256 = AutoApprove 512 = Published */
var BusinessGroupVoucherColumns;
(function (BusinessGroupVoucherColumns) {
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Default"] = 0] = "Default";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Id"] = 1] = "Id";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Code"] = 2] = "Code";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Accepted"] = 4] = "Accepted";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Rejected"] = 8] = "Rejected";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Pending"] = 16] = "Pending";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["UsageLimit"] = 32] = "UsageLimit";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["StartDate"] = 64] = "StartDate";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["ExpirationDate"] = 128] = "ExpirationDate";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["AutoApprove"] = 256] = "AutoApprove";
    BusinessGroupVoucherColumns[BusinessGroupVoucherColumns["Published"] = 512] = "Published";
})(BusinessGroupVoucherColumns = exports.BusinessGroupVoucherColumns || (exports.BusinessGroupVoucherColumns = {}));
/** 0 = Default 1 = Id 2 = Name 4 = Prefix 8 = PhoneNumber 16 = Address 32 = Email 64 = LogoReference 128 = ThemeColor 256 = AnnualGoal 512 = UsersLimit 1024 = CurrentUsage 2048 = IsActive 4096 = ExpiresOn */
var BusinessGroupColumns;
(function (BusinessGroupColumns) {
    BusinessGroupColumns[BusinessGroupColumns["Default"] = 0] = "Default";
    BusinessGroupColumns[BusinessGroupColumns["Id"] = 1] = "Id";
    BusinessGroupColumns[BusinessGroupColumns["Name"] = 2] = "Name";
    BusinessGroupColumns[BusinessGroupColumns["Prefix"] = 4] = "Prefix";
    BusinessGroupColumns[BusinessGroupColumns["PhoneNumber"] = 8] = "PhoneNumber";
    BusinessGroupColumns[BusinessGroupColumns["Address"] = 16] = "Address";
    BusinessGroupColumns[BusinessGroupColumns["Email"] = 32] = "Email";
    BusinessGroupColumns[BusinessGroupColumns["LogoReference"] = 64] = "LogoReference";
    BusinessGroupColumns[BusinessGroupColumns["ThemeColor"] = 128] = "ThemeColor";
    BusinessGroupColumns[BusinessGroupColumns["AnnualGoal"] = 256] = "AnnualGoal";
    BusinessGroupColumns[BusinessGroupColumns["UsersLimit"] = 512] = "UsersLimit";
    BusinessGroupColumns[BusinessGroupColumns["CurrentUsage"] = 1024] = "CurrentUsage";
    BusinessGroupColumns[BusinessGroupColumns["IsActive"] = 2048] = "IsActive";
    BusinessGroupColumns[BusinessGroupColumns["ExpiresOn"] = 4096] = "ExpiresOn";
})(BusinessGroupColumns = exports.BusinessGroupColumns || (exports.BusinessGroupColumns = {}));
/** 0 = Default 1 = Id 2 = CreatedOn 4 = Quantity */
var BusinessGroupQuantityColumns;
(function (BusinessGroupQuantityColumns) {
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["Default"] = 0] = "Default";
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["Id"] = 1] = "Id";
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["CreatedOn"] = 2] = "CreatedOn";
    BusinessGroupQuantityColumns[BusinessGroupQuantityColumns["Quantity"] = 4] = "Quantity";
})(BusinessGroupQuantityColumns = exports.BusinessGroupQuantityColumns || (exports.BusinessGroupQuantityColumns = {}));
/** 0 = Default 1 = Id 2 = StartsOn 4 = ExpiresOn 8 = Notes */
var BusinessGroupSubscriptionColumns;
(function (BusinessGroupSubscriptionColumns) {
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["Default"] = 0] = "Default";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["Id"] = 1] = "Id";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["StartsOn"] = 2] = "StartsOn";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["ExpiresOn"] = 4] = "ExpiresOn";
    BusinessGroupSubscriptionColumns[BusinessGroupSubscriptionColumns["Notes"] = 8] = "Notes";
})(BusinessGroupSubscriptionColumns = exports.BusinessGroupSubscriptionColumns || (exports.BusinessGroupSubscriptionColumns = {}));
/** 0 = Default 1 = Id 2 = UserId 4 = Email 8 = Text 16 = CreatedDate 32 = State 64 = CustomerSupportTicketUrl 128 = TicketId */
var ContactUsColumns;
(function (ContactUsColumns) {
    ContactUsColumns[ContactUsColumns["Default"] = 0] = "Default";
    ContactUsColumns[ContactUsColumns["Id"] = 1] = "Id";
    ContactUsColumns[ContactUsColumns["UserId"] = 2] = "UserId";
    ContactUsColumns[ContactUsColumns["Email"] = 4] = "Email";
    ContactUsColumns[ContactUsColumns["Text"] = 8] = "Text";
    ContactUsColumns[ContactUsColumns["CreatedDate"] = 16] = "CreatedDate";
    ContactUsColumns[ContactUsColumns["State"] = 32] = "State";
    ContactUsColumns[ContactUsColumns["CustomerSupportTicketUrl"] = 64] = "CustomerSupportTicketUrl";
    ContactUsColumns[ContactUsColumns["TicketId"] = 128] = "TicketId";
})(ContactUsColumns = exports.ContactUsColumns || (exports.ContactUsColumns = {}));
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            var ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            var id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map(function (v, i) { return recurse(v, i, obj); });
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (var i = 0; i < refs.length; i++) {
        var ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    var mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    var result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
